// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.feature-search-body {
    min-height: 0;
    padding: 0.25em;
    display: flex;
    flex-direction: column;
}

div.feature-search-selection {
    flex: 0 0 auto;
}

div.feature-search-selection > select {
    width: 100%;
}

form.feature-search-form {
    flex: 0 0 auto;
}

form.feature-search-form > fieldset {
    margin: 0;
    padding: 0.25em;
    border-color: var(--border-color);
    border-style: solid;
    border-width: 0 1px 0 1px;
}

div.feature-search-form-descr {
    padding: 0.25em 0;
    border-bottom: 1px solid var(--border-color);
    margin-bottom: 0.25em;
}

form.feature-search-form > fieldset table {
    width: 100%;
}

form.feature-search-form > fieldset td > input,
form.feature-search-form > fieldset td > select {
    width: 100%;
}

div.feature-search-bar > button {
    width: 100%;
}

div.feature-search-bar > button > div.Spinner {
    width: 2em;
    height: 2em;
    margin-right: 1em;
}

div.feature-search-results {
    flex: 1 1 auto;
    overflow-y: auto;
}

div.feature-search-noresults {
    font-style: italic;
    padding: 0.25em;
    margin-top: 0.25em;
    border: 1px solid var(--border-color);
    color: var(--text-color-disabled);
}`, "",{"version":3,"sources":["webpack://./plugins/style/FeatureSearch.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iCAAiC;IACjC,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,4CAA4C;IAC5C,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,qCAAqC;IACrC,iCAAiC;AACrC","sourcesContent":["div.feature-search-body {\n    min-height: 0;\n    padding: 0.25em;\n    display: flex;\n    flex-direction: column;\n}\n\ndiv.feature-search-selection {\n    flex: 0 0 auto;\n}\n\ndiv.feature-search-selection > select {\n    width: 100%;\n}\n\nform.feature-search-form {\n    flex: 0 0 auto;\n}\n\nform.feature-search-form > fieldset {\n    margin: 0;\n    padding: 0.25em;\n    border-color: var(--border-color);\n    border-style: solid;\n    border-width: 0 1px 0 1px;\n}\n\ndiv.feature-search-form-descr {\n    padding: 0.25em 0;\n    border-bottom: 1px solid var(--border-color);\n    margin-bottom: 0.25em;\n}\n\nform.feature-search-form > fieldset table {\n    width: 100%;\n}\n\nform.feature-search-form > fieldset td > input,\nform.feature-search-form > fieldset td > select {\n    width: 100%;\n}\n\ndiv.feature-search-bar > button {\n    width: 100%;\n}\n\ndiv.feature-search-bar > button > div.Spinner {\n    width: 2em;\n    height: 2em;\n    margin-right: 1em;\n}\n\ndiv.feature-search-results {\n    flex: 1 1 auto;\n    overflow-y: auto;\n}\n\ndiv.feature-search-noresults {\n    font-style: italic;\n    padding: 0.25em;\n    margin-top: 0.25em;\n    border: 1px solid var(--border-color);\n    color: var(--text-color-disabled);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
